<template>
  <div class="post-thumbnail">
    <v-card-media v-if="post.thumbnailUrl" :src="post.thumbnailUrl" height="112"></v-card-media>
    <post-default-thumbnail v-else></post-default-thumbnail>

    <div class="title">
      {{ post.title }}
      <inline-badge v-if="updated"></inline-badge>
    </div>
  </div>
</template>

<script>

import PostDefaultThumbnail from '@/components/PostDefaultThumbnail';
import InlineBadge from '@/components/InlineBabge';

export default {
  name: 'post-thumbnail',
  components: {
    PostDefaultThumbnail,
    InlineBadge,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    updated: true,
  },
};

</script>

<style scoped>

.post-thumbnail {
  width: 200px;
  /*height: 80px;*/
  /*border: dashed 1px grey;*/
}

.title {
  font-size: 18px !important;
  margin-top: 7px;
  color: rgba(0,0,0,.87);
  text-decoration: none;
}

.counters {
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  color: rgba(0,0,0, .3);
  /*justify-content: space-between;*/
}

.counters span,
span.media {
  margin-right: 2px;
  color: rgba(0,0,0, .3);
  font-size: 12px;
}

.counters span.counter,
span.media.counter {
  margin-right: 7px;
}

.counters .icon,
span.media .icon {
  font-size: 20px;
  margin-right: 1px;
  color: rgba(0,0,0, .15);
}

.publicity .icon {
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostThumbnail.vue